export default "__VITE_PUBLIC_ASSET__980ed5c7__"